import { forwardRef, PropsWithChildren } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';

import styles from './SectionContainer.module.scss';

interface ISectionContainerProps extends PropsWithChildren {
  id?: string;
  className?: string;
}

export const SectionContainer = forwardRef<HTMLElement, ISectionContainerProps>(({ children, className, id }, ref) => (
  <Box ref={ref} className={clsx(styles.container, className)} id={id}>
    {children}
  </Box>
));

SectionContainer.displayName = 'SectionContainer';
